// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import {
  CadastrarCaracteristicasDTO,
  CaracteristicasEmprendimento,
} from "../../../interfaces/CaracteristicasEmprendimento";
import { cadastrarCaracteristicasEmpreendimentoService } from "../../../services/cadastrarCaracteristicasEmpreendimentoService";
import { excluirCaracteristicasEmpreendimentoService } from "../../../services/excluirCaracteristicasEmpreendimentoService";

export const useCadastrarCaracteristicasEmpreendimento = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (
    values: CadastrarCaracteristicasDTO,
    caracteristicasEmpreend: CaracteristicasEmprendimento[]
  ) => {
    setIsLoading(true);

    try {
      const idsOriginais = caracteristicasEmpreend.map(
        (c) => c.caracteristicaId
      );

      const idsNovos = values.caracteristicaId;

      const idsParaAdicionar = idsNovos.filter(
        (id) => !idsOriginais.includes(id)
      );

      const itensParaRemover = caracteristicasEmpreend.filter(
        (c) => !idsNovos.includes(c.caracteristicaId)
      );

      await Promise.all(
        idsParaAdicionar.map((id) =>
          cadastrarCaracteristicasEmpreendimentoService({
            empreendId: values.empreendId,
            caracteristicaId: id,
          })
        )
      );

      await Promise.all(
        itensParaRemover.map((c) =>
          excluirCaracteristicasEmpreendimentoService(c.id)
        )
      );

      setSuccess("Características atualizadas com sucesso!");
    } catch (error) {
      setError(
        "Não foi possível atualizar as características, por favor tente novamente!"
      );
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { cadastrar, isLoading, error, success, resetSuccess, resetError };
};
